export default "__VITE_ASSET__CmlAihN5__"